import { List } from 'immutable'
import { handleActions } from 'redux-actions'
import * as actions from './actions'
import { Videos, Video } from 'store/records/videos'

const handleRequest = state => state.set('pending', true)

const handleFail = state => state.set('pending', false)

const handleGetVideoSuccess = (state, { payload }) => {
  return state
    .set('items', List(payload.map(el => new Video(el))))
    .set('pending', false)
    .set('loaded', true)
}

export default handleActions(
  {
    [actions.fetchVideos]: handleRequest,
    [actions.fetchVideos.fail]: handleFail,
    [actions.fetchVideos.success]: handleGetVideoSuccess,
  },
  new Videos()
)
